<template>
  <v-container fluid class="pa-0">
    <v-list v-if="Appointments && Appointments[0]" class="py-0 OddMarkedList" dense>
      <appointment-li v-for="appointment in Appointments" :key="appointment.Id" :appointment="appointment"
        @Select="select" @Remove="deleteInBe">
      </appointment-li>
    </v-list>
    <empty-page v-else-if="!loading" :icon="'mdi-calendar-question'"
      :title="$t('servicesystem.common_objects.fallbackterms.no_appointments')"
      :message="$t('servicesystem.common_objects.fallbackterms.found_no_appointments')">
      <template v-slot:actions>
        <new-appointment-btn :large="true"></new-appointment-btn>
      </template>
    </empty-page>
    <appointment-dialog :externaltrigger="dialogtrigger" :appointmentitem="selectedAppointment" :JobDetails="JobDetails"
      @Update="update" @Delete="remove">
    </appointment-dialog>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import NewAppointmentBtn from "@/components/Buttons/NewAppointmentBtn.vue";
import AppointmentDialog from "@/components/Dialogs/AppointmentDialog.vue";
import AppointmentLi from "@/components/ListItems/AppointmentListItem.vue";
import EmptyPage from "@/components/Sections/EmptyPage.vue";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import Vue from "vue";

export default {
  name: "ViewJobPlanning",
  components: { AppointmentDialog, EmptyPage, NewAppointmentBtn, AppointmentLi },
  mixins: [clientAPI],

  data() {
    return {
      Appointments: null,
      selectedAppointment: null,
      dialogtrigger: 0,
      loading: true,
    };
  },

  mounted() {
    this.$store.dispatch("NotificationStore/subscribe", [
      SRConst.EventKeys.AppointmentChange,
      this.handleSignalREvent
    ]);
    this.getJobAppointments().then(() => {
      const targetId = this.$route.params.appointmentId;
      if (targetId === "new") {
        this.$store.dispatch("triggerevents/triggerAppointment");
      } else {
        var target = this.Appointments.filter(function (x) {
          return "" + x.Id === "" + targetId;
        });
        if (target[0]) {
          this.select(target[0]);
        }
      }
    });
  },

  beforeDestroy() {
    this.$store.dispatch("NotificationStore/unsubscribe", [
      SRConst.EventKeys.AppointmentChange,
      this.handleSignalREvent
    ]);
  },

  methods: {
    async handleSignalREvent(data) {
      if (data.jobId == this.PartentJobId) { //if appointment event belonged to this job
        const id = data.appointmentId;
        switch (data.changeType) {
          case SRConst.AppointmentChangeTypes.New:
            var newapp = await this.getAppointment(id);
            this.Appointments.push(newapp);
            this.flashAppointmentState(newapp, 'new');
            break;
          case SRConst.AppointmentChangeTypes.Change:
            var updated = await this.getAppointment(id);
            var index = this.Appointments.findIndex((x) => x.Id == id);
            Vue.set(this.Appointments, index, updated);
            this.flashAppointmentState(updated, 'changed');
            break;
          case SRConst.AppointmentChangeTypes.Delete:
            var deleted = this.Appointments.find((x) => x.Id == id);
            this.flashAppointmentState(deleted, 'deleted', () => { this.Appointments = this.Appointments.filter((x) => x.Id !== id); });
            break;
          default:
            console.error('Unknown AppointmentChangeType', data.changeType);
            break;
        }
      }
    },

    flashAppointmentState(target, state, onComplete) {
      Vue.set(target, state, true);
      setTimeout(() => {
        Vue.set(target, state, false);
        if (onComplete != undefined) {
          onComplete();
        }
      }, 4000);
    },

    async getJobAppointments() {
      this.loading = true;
      await this.getAppointmentsByJobId(this.PartentJobId)
        .then((response) => {
          this.Appointments = response;

        })
        .catch((exception) => console.log(exception))
        .finally(() => (this.loading = false));
    },

    select(appointment) {
      this.selectedAppointment = appointment;
      if ("" + appointment.Id != "" + this.$route.params.appointmentId) {
        this.$router.push({ params: { appointmentId: appointment.Id } });
      }
      this.dialogtrigger++;
    },

    update(inAppointment) {
      if (!inAppointment.new) {
        var index = 0;
        while (index > -1 && index < this.Appointments.length) {
          var existing = this.Appointments[index];
          if (existing.Id === inAppointment.Id) {
            Vue.set(this.Appointments, index, inAppointment);
            index = -2;
          }
          index++;
        }
      }

      this.getJobById(this.$route.params.jobId)
        .then((response) => {
          this.$store.dispatch("JobHub/clearJob");
          this.$store.dispatch("JobHub/JobUpdater/UpdateEntireJob", response);
          this.getJobAppointments();
        })
        .catch((exception) => console.log(exception))
        .finally(() => (this.loading = false));

      //this.Appointments.unshift(inAppointment);
    },

    remove(id) {
      this.Appointments = this.Appointments.filter((x) => x.Id !== id);
    },

    deleteInBe(id) {
      this.deleteAppointment(id)
        .then(() => {
          this.remove(id);
        })
        .catch((exception) => console.error(exception))
        .finally(() => (this.loading = false));
    },
  },

  computed: {
    PartentJobId() {
      return this.$route.params.jobId;
    },
    JobDetails() {
      return this.$store.getters["JobHub/JobDetails"];
    },
  },

  watch: {},
};
</script>